module.exports = __webpack_public_path__ + "img/icon_opacity.cb2e9a43.png";